import React from "react";
import moment from "moment";

interface HolidayDateBadgeProps {
  holidayDate: string;
}

export const HolidayDateBadge: React.FC<HolidayDateBadgeProps> = ({
  holidayDate,
}) => {
  const month = holidayDate
    ? moment(holidayDate).format("MMM").toUpperCase()
    : "";

  const day = holidayDate ? moment(holidayDate).format("DD") : "";

  return (
    <p className="flex flex-col items-center rounded-lg bg-grey-100 px-3 py-1">
      <span className="text-[12px] font-semibold text-grey-600">{month}</span>
      <span className="text-sm font-bold text-grey-900">{day}</span>
    </p>
  );
};
